import { useEffect, useState } from "react";
import axios from 'axios';

export default function NotificationPreferences() {
    const [prefs, setPrefs] = useState(null);
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        axios.get("/api/notification-preferences/")
            .then(res => setPrefs(res.data));
    }, []);

    function handleChange(field) {
        const updated = { ...prefs, [field]: !prefs[field] };
        setPrefs(updated);
        setSaving(true);
        axios.patch("/api/notification-preferences/", { [field]: updated[field] })
            .finally(() => setSaving(false));
    }

    if (!prefs) return <p>Loading…</p>;

    return (
        <section>
            <h2>Email Notification Preferences</h2>
            {["info", "alert", "payment", "subscription", "events"].map(key => (
                <label key={key} style={{ display: "block", marginBottom: "8px" }}>
                    <input
                        type="checkbox"
                        checked={prefs[key]}
                        onChange={() => handleChange(key)}
                        disabled={saving}
                    />
                    &nbsp;{key.charAt(0).toUpperCase() + key.slice(1)}
                </label>
            ))}
        </section>
    );
}